import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Metric } from '../../interfaces/metric.interface';
import { StaticMetricMenuItem } from 'Angular/services/static-menus/interfaces/static-metric-menu.interface';

import { MetricByCategoryListDirective } from '../metric-by-category-list/metric-by-category-list.directive';

/**
 * Multi Metric By Category List
 *
 * Inputs:
 *   maxMetrics: The maximum number of metrics that can be selected. Default null (No limit)
 *
 */
@Component({
    standalone: false,
    selector: 'ycn-multi-metric-by-category-list',
    templateUrl: '../metric-by-category-list/metric-by-category-list.template.html',
})
export class MultiMetricByCategoryListComponent extends MetricByCategoryListDirective {
    @Input() maxMetrics: number | null = null;

    @Output() maxLimitReachedHandler = new EventEmitter<boolean>();

    /**
     * Select a metric. This includes updating the selectedMetricMap so checkmarks are displayed for selected metrics
     * @param metric: The selected metric.
     * @param categoryLabel: The category label of the selected metric.
     * @param sectionLabel: The section label of the selected metric.
     * @param menuLabel: If the metric is part of a submenu under a section, this is the menu label of the selected
     *   metric. A blank string means the metric is not part of a submenu.
     */
    selectMetric(metric: StaticMetricMenuItem, categoryLabel: string, sectionLabel: string, menuLabel?: string): void {
        const unselectMetric = this.getSelectedMetrics().find(
            (selectedMetric) => metric.internal_name === selectedMetric.internal_name
        );
        const metricInfo = {
            id: metric.internal_name,
            metric: metric as Metric,
            categoryLabel,
            sectionLabel,
            menuLabel,
        };
        const validMetricToSelect = this.maxMetrics === null || this.maxMetrics > this.getSelectedMetrics().length;
        if (validMetricToSelect || unselectMetric) {
            this.addSelectedMetricToMaps(metricInfo);
            if (this.maxMetrics !== null) {
                this.maxLimitReachedHandler.emit(false);
            }
        } else if (this.maxMetrics !== null) {
            this.maxLimitReachedHandler.emit(true);
        }
    }

    getSelectedMetrics(): Metric[] {
        return this.selectedMetricsList;
    }
}
